import { Group, Paper, Stack, Text, Title } from "@mantine/core";
import { IconCircleArrowRight, IconCoinEuro } from "@tabler/icons-react";
import { AnchorLink } from "../../../AnchorLink/AnchorLink";
import "../SalesCardLink.scss";

function StromsteuerSalesCard() {
  return (
    <Paper>
      <Group justify="space-between">
        <Title order={6} size="h4">
          Stromsteuer Add-On
        </Title>
        <IconCoinEuro color="var(--mantine-primary-color-filled)" />
      </Group>
      <Stack gap="xs">
        Dieser Reiter ist Teil des Add-Ons Stromsteuer. Keines der Unternehmen
        in Ihrem Projekt ist dafür freigeschaltet.
        <Text fw={500} fz="h4">
          <AnchorLink
            className="sales-card-link"
            href="https://go.node.energy/opti.node-cockpit-angebot-stromsteuer?utm_source=opti.node&utm_medium=link"
          >
            <IconCircleArrowRight size="1.3em" />
            Bei Interesse an dem Modul können Sie hier Sales kontaktieren.
          </AnchorLink>
        </Text>
      </Stack>
    </Paper>
  );
}

export { StromsteuerSalesCard };
